import { InjectionToken, Provider } from '@angular/core';

import { Environment } from '@personalized-supplements/environments/env';
import { environment } from '@personalized-supplements/environments/environment';

export const ENVIRONMENT = new InjectionToken<Environment>('ENVIRONMENT');

export const environmentProvider: Provider = {
  provide: ENVIRONMENT,
  useValue: environment,
};
